
import store_consultation from '@/store/mods/clinique/consultations'
import { parseBackendTimestamp } from '@/utils/backend-timestamp'

export default {
    name: 'reattribution-consultation',
    data() {
        return {
            is_open: true, is_alive: true, is_loading: false, is_saving: false,
            liste_a_jour: false,
            session_expiree: false,
            liste_consultations: [], liste_medecins: [], annuaire_medecins: [], ligne_selectionnee: null,
            nouveau_medecin_id: '', filtre_recherche: '',
            filtre_date: '',
            page_courante: 1, total_pages: 1, total_lignes: 0,
            message_erreur: '', message_succes: '', sequence_requete: 0, recherche_timer: null
        }
    },
    computed: {
        medecins_eligibles() {
            if (!this.ligne_selectionnee) return []
            const row = this.ligne_selectionnee
            const eligible_ids = (row.eligible_doctor_ids || []).map(Number)
            return this.liste_medecins.filter(doctor => eligible_ids.indexOf(Number(doctor.id)) !== -1 && Number(doctor.id) !== Number(row.doctor_id))
        },
        peut_confirmer() {
            return this.liste_a_jour && !this.is_saving && !this.is_loading && !!this.ligne_selectionnee &&
                this.medecins_eligibles.some(doctor => Number(doctor.id) === Number(this.nouveau_medecin_id))
        }
    },
    mounted() { this.charger_liste() },
    beforeDestroy() {
        this.is_alive = false
        this.sequence_requete++
        clearTimeout(this.recherche_timer)
    },
    methods: {
        async charger_liste(conserver_message = false) {
            if (this.is_saving || !this.is_alive) return
            clearTimeout(this.recherche_timer)
            const sequence = ++this.sequence_requete
            this.is_loading = true
            this.session_expiree = false
            this.liste_a_jour = false
            this.ligne_selectionnee = null
            this.nouveau_medecin_id = ''
            if (!conserver_message) { this.message_erreur = ''; this.message_succes = '' }
            const payload = { search_item: this.filtre_recherche.trim(), page: this.page_courante }
            if (this.filtre_date) payload.filter_date = this.filtre_date
            let obtaining_access = true
            try {
                const access_response = await store_consultation.getReattributionAccess({})
                if (!this.is_alive || sequence !== this.sequence_requete) return
                const access_data = access_response && access_response.data
                if (!access_response.success || !access_data || !access_data.access_token || !Array.isArray(access_data.doctors)) throw new Error('Accès indisponible')
                obtaining_access = false
                const response = await store_consultation.getConsultationsReattribuables(payload, access_data.access_token)
                if (!this.is_alive || sequence !== this.sequence_requete) return
                if (!response || !Array.isArray(response.data)) throw new Error('Liste indisponible')
                this.liste_medecins = access_data.doctors
                this.annuaire_medecins = access_data.doctor_directory || access_data.doctors
                this.liste_consultations = response.data
                this.liste_a_jour = true
                this.total_lignes = Number(response.total) || 0
                this.total_pages = Number(response.last_page) || 1
                this.page_courante = Number(response.current_page) || 1
                if (this.page_courante > this.total_pages) {
                    this.page_courante = this.total_pages
                    return this.charger_liste(conserver_message)
                }
            } catch (error) {
                if (!this.is_alive || sequence !== this.sequence_requete) return
                const status = error.response && error.response.status
                this.session_expiree = status === 401 && obtaining_access
                this.message_erreur = status === 403 ? 'Vous ne disposez pas de l’accès à la réattribution.' :
                    status === 401 ? (obtaining_access ? 'Votre session ne peut plus être authentifiée. Reconnectez-vous puis rouvrez cette fenêtre.' : 'Votre accès a expiré. Actualisez la liste pour réessayer.') :
                    'Impossible de charger les consultations. Actualisez pour réessayer.'
            } finally {
                if (this.is_alive && sequence === this.sequence_requete) this.is_loading = false
            }
        },
        rechercher() {
            if (this.is_saving) return
            clearTimeout(this.recherche_timer)
            this.sequence_requete++
            this.liste_a_jour = false
            this.ligne_selectionnee = null
            this.recherche_timer = setTimeout(() => this.appliquer_filtres(), 300)
        },
        appliquer_filtres() {
            if (this.is_saving) return
            this.page_courante = 1
            return this.charger_liste()
        },
        changer_page(page) {
            if (this.is_saving || this.is_loading || page < 1 || page > this.total_pages) return
            this.page_courante = page
            return this.charger_liste()
        },
        choisir_ligne(row) {
            if (this.is_saving || this.is_loading || !this.liste_a_jour) return
            this.ligne_selectionnee = row
            this.nouveau_medecin_id = ''
            this.message_erreur = ''
            this.message_succes = ''
        },
        annuler_choix() {
            if (this.is_saving) return
            this.ligne_selectionnee = null
            this.nouveau_medecin_id = ''
        },
        async confirmer_reattribution() {
            if (!this.peut_confirmer || !this.is_alive) return
            const row = this.ligne_selectionnee
            const doctor_id = Number(this.nouveau_medecin_id)
            this.is_saving = true
            this.message_erreur = ''
            this.message_succes = ''
            clearTimeout(this.recherche_timer)
            let recharger = false
            let obtaining_access = true
            try {
                // Fresh write capability is bound to the selected doctor, never stored persistently.
                const access_response = await store_consultation.getReattributionAccess({ doctor_id })
                if (!this.is_alive) return
                const access_data = access_response && access_response.data
                if (!access_response.success || !access_data || !access_data.access_token) throw new Error('Accès indisponible')
                obtaining_access = false
                const response = await store_consultation.reattribuerConsultation(row.consultation_id,
                    { doctor_id, expected_doctor_id: Number(row.expected_doctor_id) || 0 }, access_data.access_token)
                if (!this.is_alive) return
                if (!response || !response.success) throw new Error('Réattribution non confirmée')
                this.message_succes = 'Consultation réattribuée.'
                recharger = true
            } catch (error) {
                if (!this.is_alive) return
                const status = error.response && error.response.status
                if (status === 409) {
                    this.message_erreur = 'Cette consultation a été modifiée ou démarrée entre-temps. La liste a été actualisée.'
                    recharger = true
                } else if (status === 403 || status === 404 || status === 422) {
                    this.message_erreur = 'La consultation ou le médecin choisi n’est plus disponible pour cette réattribution. Vérifiez la liste actualisée.'
                    recharger = true
                } else {
                    this.session_expiree = status === 401 && obtaining_access
                    this.message_erreur = status === 401 && obtaining_access
                        ? 'Votre session ne peut plus être authentifiée. Reconnectez-vous puis rouvrez cette fenêtre. Aucune réattribution n’a été envoyée.'
                        : 'Impossible de confirmer la réattribution. Actualisez la liste pour vérifier avant de réessayer.'
                    this.liste_a_jour = false
                    this.ligne_selectionnee = null
                    this.nouveau_medecin_id = ''
                }
            } finally {
                if (this.is_alive) this.is_saving = false
            }
            if (recharger && this.is_alive) await this.charger_liste(true)
        },
        avant_fermeture(event) {
            if (this.is_saving) event.preventDefault()
        },
        fermer() { if (!this.is_saving) this.is_open = false },
        nom_medecin(doctor_id) {
            if (!Number(doctor_id)) return 'Non attribué'
            const doctor = this.annuaire_medecins.find(item => Number(item.id) === Number(doctor_id))
            return doctor ? doctor.nom : 'Médecin non disponible dans l’annuaire'
        },
        format_arrivee(value) {
            if (!value) return '—'
            const date = parseBackendTimestamp(value)
            if (Number.isNaN(date.getTime())) return '—'
            return date.toLocaleString('fr-FR', { timeZone: this.getClinicTimezone(), day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
        }
    }
}
